import { productBundleExtractionsService } from '@/services/estimation/product-bundle-extractions.service';
import axios from 'axios';

const initialState = () => ({
  productBundleExtraction: null,
  productBundleExtractionRunning: false,
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const CancelToken = axios.CancelToken;
let cancelTokens = {
  productExtractionById: null,
};

const actions = {
  // Get an extraction container by its id
  getProductBundleExtractionById({ commit }, { id }) {
    if (cancelTokens.productExtractionById) cancelTokens.productExtractionById.cancel('Multiple requests.');
    cancelTokens.productExtractionById = CancelToken.source();

    commit('GET_EXTRACTION');
    return productBundleExtractionsService
      .getProductBundleExtractionById({ id, cancelToken: cancelTokens.productExtractionById })
      .then(
        (extraction) => {
          commit('SUCCESS', extraction);
          return extraction;
        },
        (error) => {
          if (axios.isCancel(error)) return;
          commit('ERROR', error.response);
          throw error;
        },
      );
  },
};

const mutations = {
  GET_EXTRACTION(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  SUCCESS(state, extraction) {
    state.status = {
      error: null,
      pending: false,
      resolved: true,
      rejected: false,
    };
    state.productBundleExtraction = extraction;
    state.productBundleExtractionRunning =
      state.productBundleExtraction &&
      state.productBundleExtraction.status !== 'COMPLETED' &&
      state.productBundleExtraction.status !== 'ERROR';
  },
  ADD_PRODUCT_BUNDLE_EXTRACTION_OUTPUT_FILE(state, files) {
    files.forEach((file) => {
      state.productBundleExtraction.outputFiles.push(file);
    });
  },
  DELETE_OUTPUT_FILE_SUCCESS(state, { fileId }) {
    state.productBundleExtraction.outputFiles = state.productBundleExtraction.outputFiles.filter(
      (file) => file.id !== fileId,
    );
  },
  ERROR(state, error) {
    state.status = {
      ...state.status,
      error: error,
      pending: false,
      rejected: true,
    };
    state.productBundleExtraction = null;
    state.productBundleExtractionRunning = false;
  },
};

const getters = {
  productBundleExtraction: (state) => state.productBundleExtraction,
  productBundleExtractionRunning: (state) => state.productBundleExtractionRunning,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const productBundleExtraction = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
